<template>
  <div>
    <b-row>
      <!----- SideBar All Design List ---->
      <div class="fileside">
        <sidebarAllDesignsComponent></sidebarAllDesignsComponent>
      </div>
      <!-- <sidebarAllDesignsComponent></sidebarAllDesignsComponent> -->
      <!----- SideBar All Design List End ---->

      <div class="design-container-details__main" style="width:70%">
        <div class="brand-card brandcard">
          <div class="col-md-12" style="margin-top:10px;margin-bottom:10px;" v-if="user_type != 'Fit_Technician'">
            <div class="col-md-12">
              Design Title:<strong>
                &nbsp;{{ style_details.design_title }}</strong
              >
            </div>
            <div class="col-md-12">
              Style Name : &nbsp;{{ style_details.style_name }} >>
              {{ style_details.sub_cattitle }}
            </div>
            <div class="col-md-12">No Records Found
              Created Date : {{ style_details.created_date }}
            </div>
            <div v-if="this.style_details.sendqname === null" class="col-md-12">
              Buyer Name : {{ style_details.buyer_name }}
            </div>
            <div v-if="this.style_details.sendqname != null" class="col-md-12">
              Buyer Name : {{ style_details.sendqname }}
            </div>
          </div>

          <!-- Code For Tab -->
          <navbarMenu :files="all_Files_uploaded"></navbarMenu>
          <br />

          <div class="col-md-12 ">
            <!-- <div> -->
            <!-- <b-card  style="padding-top:10px;"> -->
            <!--- Files Tab --->
            <!-- <b-tabs> -->
            
            <div class="col-md-12 tabledesign">
              <b-button
                style="float:right;margin-bottom:5px;"
                @click="uploadfilemodelfunction()"
                variant="primary"
                aria-pressed="true"
                class="fa fa-paperclip fa-2x"
                v-if=" ((style_details.assigned_to === null && style_details.user_type === 'Brand_Designer') || (style_details.assigned_to === null && style_details.user_type === 'Brand_Manager') || (style_details.assigned_to != null && user_type == 'Fit_Technician') ||  (style_details.operational_status == 'TP-Uploaded' || style_details.operational_status == 'BOM-Updated' || style_details.operational_status == 'Measurement Chart-Uploaded') || (user_type === 'Buyer' && style_details.operational_status == 'FH-approved') ) &&
                 ( user_type != 'Quality_Controller' &&
                    user_type != 'Quality_Executive' &&
                    user_type != 'Buying_Head')
                "
              ></b-button>

              <!-- <table class="table">
                <thead>
                  <tr class="trhead">
                    <th>File Name</th>
                    <th>Category</th>
                    <th>File Version</th>
                    <th>Uploaded Date</th>
                    <th>Uploaded By</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody v-if="filemessage != ''">
                  <tr class="trbody" v-for="file_list in files_list">
                    <td style="word-break: break-all;width: 272px;">
                      {{ file_list.file_name }}
                    </td>
                    <td>{{ file_list.category_name }}</td>
                    <td>{{ file_list.file_version }}.0</td>
                    <td>{{ file_list.created_date }}</td>
                    <td v-if="file_list.uploaded_by != null">
                      {{ file_list.uploaded_by }}
                    </td>
                    <td v-if="file_list.uploaded_by == null">NA</td>
                    <td>
                    
                      <a :href="file_list.file_path" target="_blank"
                        ><i
                          class="fa fa-download"
                          aria-hidden="true"
                          style="color: green; margin-left: 5px;"
                          >&nbsp;</i
                        ></a
                      >
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-if="
                    filemessage ==
                      'Please upload Techpack,Measurement Chart and BOM files'
                  "
                >
                  <td colspan="4" style="text-align: center;">
                    No Records Found
                  </td>
                </tbody>
              </table> -->
            </div>
          </div>
        
          <div class="accordion col-md-12" role="tablist" style="margin-left:-1%;"  v-for="(file_list,index) in files_list" :key="file_list">
        
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block  v-b-toggle="'accordion' + index" variant="light" style="text-align: left;">{{file_list.category_name}} &emsp; - &emsp;<span>Version</span>  {{file_list.file_version}}.0  </b-button>       
              </b-card-header>
              <b-collapse :id="'accordion' + index" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <div class="col-md-12 tabledesign m-2">
                      <b-button
                        style="float:right;margin-bottom:5px;"
                        @click="uploadfilemodelfunctionformultiple(file_list.file_version,file_list.category_name)"
                        variant="primary"
                        aria-pressed="true"
                        class="fa fa-paperclip fa-2x"
                        v-if=" ((style_details.assigned_to === null && style_details.user_type === 'Brand_Designer') || (style_details.assigned_to === null && style_details.user_type === 'Brand_Manager') || (style_details.assigned_to != null && user_type == 'Fit_Technician') ||  style_details.operational_status == 'TP-Uploaded' || style_details.operational_status == 'BOM-Updated' || style_details.operational_status == 'Measurement Chart-Uploaded') &&
                          ( user_type != 'Quality_Controller' &&
                              user_type != 'Quality_Executive' &&
                              user_type != 'Buying_Head')
                          "
                      ></b-button>
                    </div>

                    <table class="table mt-3 border" >
                      <thead>
                        <tr class="trhead">
                          <th>File Name</th>
                          <th>File Version</th>
                          <th>Uploaded Date</th>
                          <th>Uploaded By</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody v-if="filemessage != ''" v-for="versionlog,idx in file_list.version_log" :key="versionlog">
                        <tr class="trbody">
                          <td style="word-break: break-all;width: 272px;">
                            {{ versionlog.file_name }}
                          </td>
                          <td>{{ versionlog.version+'.'+idx }}</td>
                          <td>{{ versionlog.created_date }}</td>
                          <td v-if="versionlog.uploaded_by != null">
                            {{ versionlog.uploaded_by }}
                          </td>
                          <td v-if="versionlog.uploaded_by == null">NA</td>
                          <td>
                          
                            <a :href="versionlog.file_url" target="_blank" class="m-1">
                              <b-button><i
                                class="fa fa-download"
                                aria-hidden="true"
                                style="color: green; margin-left: 5px;"
                                >&nbsp;</i
                              ></b-button>
                            </a>
        
                            <b-button @click="()=>openDownloadLogModel(versionlog.file_id)" class="m-1">
                              <i
                                class="fa fa-info"
                                aria-hidden="true"
                                style="color:black; margin-left: 5px;"
                              >&nbsp;</i>
                            </b-button>
                          </td>
                        </tr>
                      </tbody>
                      <tbody
                        v-if="
                          filemessage ==
                            'Please upload Techpack,Measurement Chart and BOM files'
                        "
                      >
                        <td colspan="4" style="text-align: center;">
                          No Records Found
                        </td>
                      </tbody>
                    </table> 
                </b-card-body>
              </b-collapse>
            </b-card>
          
          </div>

          <!-- Code For Tab Ends -->

          
        </div>
      </div>

      <!-- Add File Model -->
      <b-modal
        title="Upload File"
        v-model="uploadfilemodel"
        @ok="uploadfilemodel = false"
      >
        <b-form
          name="fileform"
          @submit.prevent="validateForm('form-1')"
          data-vv-scope="form-1"
        >
          <b-col class="filedesign">
            <b-col sm="12">
              <b-form-group>
                <label for="name">File Type</label>
                <b-input-group class="mb-3">
                <!-- <b-form-select id="month1"
                  :plain="true"
                  v-model="file_category"
                  :options="file_Category_options">
                </b-form-select> -->
                <!-- || user_type=='Design_Head' -->
                <b-form-select
                  v-model="file_category"
                  name="file_category"
                  required
                  :class="{
                    input: true,
                    'text-danger': errors.has('form-1.file_category'),
                  }"
                  @change="selectfilecategory()"
                >
                  <option value="">--Select--</option>
                  <option
                    :disabled="this.selectedfilename === 'Measurement Chart' || this.selectedfilename === 'BOM' || this.selectedfilename === 'CAD'"
                    value="Techpack"
                    v-if="
                      user_type == 'Brand_Designer' ||
                        user_type == 'Buyer' ||
                        user_type == 'Brand_Manager' ||
                         user_type == 'Junior_Buyer' 
                    "
                    >Techpack</option
                  >
                  <!-- || user_type=='Buyer'  || user_type=='Brand_Manager' -->
                  <option 
                    :disabled="this.selectedfilename === 'Techpack' || this.selectedfilename === 'BOM' || this.selectedfilename === 'CAD' "
                    value="Measurement Chart"
                    v-if="
                      file_status == 'FH-approved' &&
                        (user_type == 'Fit_Technician' ||
                          user_type == 'Buyer' ||
                          user_type == 'Brand_Manager')
                    "
                    >Measurement Chart</option
                  > 
                  <option 
                   :disabled="this.selectedfilename === 'Techpack' || this.selectedfilename === 'BOM' || this.selectedfilename === 'CAD' "
                    value="Measurement Chart"
                    v-if="
                      (file_status != 'FH-approved' &&
                        (user_type == 'Fit_Technician' ||
                          user_type == 'Buyer' ||
                          user_type == 'Brand_Manager' ||  user_type == 'Junior_Buyer')) ||
                        file_status == 'TP-Uploaded' ||
                        file_status == 'BOM-Updated'
                    "
                    >Measurement Chart</option
                  >
                  <!-- <option value="Measurement Chart" v-if="file_status=='FH-approved' && (user_type=='Fit_Technician' || user_type=='Buyer'  || user_type=='Brand_Manager') && (file_status=='TP-Uploaded' || file_status=='BOM-Updated') " >Measurement Chart</option> -->
                  <!-- <option value="Measurement Chart" v-if="file_status!='FH-approved' && (user_type=='Fit_Technician' || user_type=='Buyer'  || user_type=='Brand_Manager') || (file_status=='TP-Uploaded' || file_status=='BOM-Updated')">Measurement Chart</option> -->
                  <!-- || file_status=='TP-Uploaded' -->
                  <option
                   :disabled="this.selectedfilename === 'Measurement Chart' || this.selectedfilename === 'BOM' || this.selectedfilename === 'Techpack' "
                    value="CAD"
                    v-if="
                      user_type == 'Brand_Designer' ||
                        user_type == 'Vendor' ||
                        user_type == 'Buyer-approved'
                    "
                    >CAD</option
                  >

                  <!-- <option value="Technical Review Comments" v-if=" user_type=='Buyer'  || user_type=='Brand_Manager'">Technical Review Comments</option> -->

                  <option
                    value="FPT"
                    v-if="
                      user_type == 'Vendor' || user_type == 'Buyer-approved'
                    "
                    >FPT</option
                  >

                  <option
                    value="GPT"
                    v-if="
                      user_type == 'Vendor' || user_type == 'Buyer-approved'
                    "
                    >GPT</option
                  >

                  <option
                    value="Inspection Report"
                    v-if="
                      user_type == 'Quality_Head' ||
                        user_type == 'Buyer-approved'
                    "
                    >Inspection Report</option
                  >

                  <option
                   :disabled="this.selectedfilename === 'Techpack' || this.selectedfilename === 'Measurement Chart' || this.selectedfilename === 'CAD' "
                    value="BOM"
                    v-if="
                      ((user_type == 'Brand_Manager' ||
                        user_type == 'Buyer' ||
                        user_type == 'Brand_Designer' || user_type == 'Junior_Buyer'))
                    "
                    >BOM</option
                  >
                </b-form-select>

                <datalist>
                  <!-- <option :value="selected"></option>
                      <option  :value="materialinfoupperfabric_list.title" v-for="materialinfoupperfabric_list in materialinfoupperfabric_Upper_Fabric_arr"></option> -->
                 </datalist>
                    </b-input-group>


                <b-input-group class="mb-3">
                  <span class="icon has-text-warning">
                    <i
                      class="fa fa-warning"
                      v-show="errors.has('file_category')"
                    ></i>
                  </span>
                  <span
                    style="width:240px"
                    v-show="errors.has('form-1.file_category')"
                    class="help text-danger"
                    >{{ errors.first("form-1.file_category") }}</span
                  >
                </b-input-group>
              </b-form-group>

              <b-form-group v-if="file_category == 'BOM'">
                <span
                  v-b-modal.modal-bom
                  @click="showBomModal"
                  class="text-primary"
                  style="cursor: pointer;"
                >
                  Download Sample BOM File
                </span>
                <!-- <label for="name"><a href="../assets/images/MisReport.csv" download>Download Sample BOM File</a></label> -->
                <!-- <b-form-select id="month1"
                  :plain="true"
                  v-model="file_category"
                  :options="file_Category_options">
                </b-form-select> -->
              </b-form-group>

            <b-form-group>
  <label for="name">Upload File</label>

  <!-- Drag & Drop Zone -->
  <div 
    class="drag-drop-zone"
    :class="{ 'drag-over': isDragging }"
    @dragenter.prevent="handleDragEnter"
    @dragover.prevent="handleDragOver"
    @dragleave.prevent="handleDragLeave"
    @drop.prevent="handleDrop"
  >
    <div class="drag-drop-content">
      <i class="fa fa-cloud-upload fa-3x mb-3" style="color: #20a8d8;"></i>

      <p class="mb-2"><strong>Drag & drop your file here</strong></p>
      <p class="text-muted mb-2">or</p>

      <b-form-file
        ref="fileInput"
        v-model="file"
        placeholder="Click to browse"
        accept="*"
        @change="selectFile($event)"
        class="d-inline-block"
        style="max-width: 200px;"
      ></b-form-file>
    </div>
  </div>

  <!-- Show selected file -->
    <div class="progress" id="progress_bar" style="display:none; margin-top: 7px; margin-bottom: 7px; width: 100%; height: 30px;font-size: 18px; font-weight: bold;" > 
      <div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100" :style="{ height: '30px', text: '20px', align: 'center', width: progress + '%', }" > {{ progress }}% </div>
     </div>

  <!-- Progress Bar remains same -->
</b-form-group>

            </b-col>
            <div slot="footer" id="upload_btn">
               <b-button @click="closefileuploadmodal();"
                type="button"
                style="float:right"
                variant="danger"
                class="px-4 ml-2"
                >Cancel</b-button
              > 
              
              <b-button
                type="submit"
                style="float:right"
                variant="primary"
                class="px-4"
                >Upload File</b-button
              >
             
            </div>
          </b-col>
        </b-form>
      </b-modal>
      <!--  End Add File Model -->
      

      <!-- ~~~~~~~~~~~Modal for BOM Template -->
      <div>
        <b-modal id="modal-bom" hide-footer size="lg" title="BOM Templates">
          <div class="row">
            <div class="col-md-12 mb-4 text-left">
              <div class="card-body pl-3 pr-3">
                <b-card-group deck class="p-3" size="lg">
                   <b-table
                    class="mt-4"
                    caption-top
                    show-empty
                    stacked="md"
                    :busy="isBusy"
                    :items="items2"
                    :fields="fields3"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :bordered="bordered"
                    :filter="filter"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    @filtered="onFiltered"
                    >
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                    <template slot="ID" slot-scope="row">
                        {{ getRowIndex(row) }}
                    </template>
                    <template slot="filepath" slot-scope="row">
                        <button>
                        <a v-bind:href="row.item.file_path" download>
                            <i class="fa fa-download" aria-hidden="true"></i>
                        </a>
                        </button>
                    </template>
                    </b-table>
                    <b-col md="6" class="my-1">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        class="my-0"
                    ></b-pagination>
                    </b-col>
                </b-card-group>
              </div>
            </div>
          </div>
        </b-modal>
      </div>

      <!-- ~~~~~~~~~~~~~~Modal end for BOM Template -->

      <!-- vendor download version log modal starts -->
        <b-modal
          title="Vendor Download Log"
          v-model="showDownloadLogModal"
          @ok="showDownloadLogModal = false"
        >
          <b-table
          class="mt-4"
          caption-top
          show-empty
          stacked="md"
          :busy="isBusy4"
          :items="vendorDownloadLogList"
          :fields="fields4"
          ></b-table>
        </b-modal>
      <!-- vendor download version log modal ends -->
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import auth from "@/utils/auth";
import Vue from "vue";
import Router from "vue-router";
import Utils from "@/utils";
import swal from "sweetalert2";
import DateHelper from '@/utils/dateHelper'


import sidebarAllDesignsComponent from "./_sidebarAllDesignsComponent.vue";
import navbarMenu from "./_navbarMenu.vue";

const axios = require("axios");
export default {
  name: "Tabs",
  components: {
    sidebarAllDesignsComponent,
    navbarMenu,
  },

  data() {
    return {
      addfile: false,
      showSideMenu: true,
      tabs: ["Calculator", "Shopping cart", "Charts"],
      quotationAddModal: false,
      msgRows: 0,
      addfile: false,
      design_details: [],
      quateitemlist: [],
      design_title: "",
      design_id: "",
      design_date: "",
      collection_title: "",
      imgpath: "",

      quote_date: "",
      quote_quantity: "",
      quote_currency: "",
      quote_prce_per: "",
      price_per_garment: "",
      quote_status: "",
      quote_unit: "",
      quantity: "",
      brand_code: "",

      totalRows: 0,
      currentPage: 1,
      perPage: 6,

      visible: true,
      list: [],
      customer: {},
      messagedata: [],
      selectedId: 0,
      txtInput: "",
      title: "",
      design_no: "",
      uploadfilemodel: false,
      quote_tab: false,
      message_tab: false,
      files_list: [],
      nav_design_list: [],
      catselected: "",
      subcatselected: "",
      cat_title: "",
      sub_cat_title: "",

      file_title: "",
      file_category: "",
      file_url_path: "",
      file_Category_options: [
        { value: "Techpack", text: "Techpack" },
        { value: "Measurement Chart", text: "Measurement Chart" },
        { value: "CAD", text: "CAD" },
        {
          value: "Technical Review Comments",
          text: "Technical Review Comments",
        },
        { value: "FPT", text: "FPT" },
        { value: "GPT", text: "GPT" },
        { value: "Inspection Report", text: "Inspection Report" },
        { value: "BOM", text: "BOM" },
      ],
      files_fields: [
        { key: "file_name", label: "Files" },
        { key: "category_name", label: "Catagary" },
        { key: "uploaded_by", label: "Uploaded_By" },
        { key: "created_date", label: "Date" },
        { key: "download", label: "Download" },
      ],

      //Code for sampling
      requestSampleModal: false,
      requestedlisting: [],

      selectedDate: new Date(),
      items: [],
      result: [],
      sample_data: [],
      //Sampling code ends

      files_fields: [
        { key: "file_name", label: "Files" },
        { key: "category_name", label: "Catagary" },
        { key: "uploaded_by", label: "Uploaded_By" },
        { key: "created_date", label: "Date" },
        { key: "download", label: "Download" },
      ],

      fields1: [
        {
          key: "price_per_garment",
          label: "Price per garment",
          sortable: true,
          sortDirection: "desc",
        },
        { key: "quantity", label: "Quantity", sortable: true },
        { key: "quantity_currency", label: "Currancy", sortable: true },
        ,
      ],

      quoteunit: [{ value: "INR", text: "INR" }],

      activeTab: 1,
      //New Added Code
      filename: "",
      filetype: "",
      img_name: "",
      route_id: "",
      file: "",
      style_details: [],
      user_type: "",
      created_date: "",
      uploaded_by: "",
      fileObj: [],
      fileObj_msg: "",
      tp_status: false,
      measurementchart_status: false,
      bom_status: false,
      fileupload_status: false,
      file_status: "",
      items1: [
        {
          FabricConsumtion: "",
          Fabrictype: "",
          Weight: 0,
          quantity: 0,
          price: 0,
          rateunit: "",
          Consumptionunit: "",
        },
      ],
      file_tab_status: false,
      component_name: "design_files",
      name: "auth",
      filemessage: "",
      progress: 0,
      selectedFiles: "",

      sizeset: [],
      invoice_products: [
        {
          unit: [],
          selectedfromage: [],
          selectedtoage: [],
          factorysize: [],
        },
      ],
      selected_month: [],
      selected_age: 0,
      selectedfromage: [],
      selectedtoage: [],
      quantity: [],
      factorysize: [],
      month_arr: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
        { value: "17", text: "17" },
        { value: "18", text: "18" },
        { value: "19", text: "19" },
        { value: "20", text: "20" },
        { value: "21", text: "21" },
        { value: "22", text: "22" },
        { value: "23", text: "23" },
        { value: "24", text: "24" },
      ],
      year_arr: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
      ],
      to_month_arr: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
        { value: "17", text: "17" },
        { value: "18", text: "18" },
        { value: "19", text: "19" },
        { value: "20", text: "20" },
        { value: "21", text: "21" },
        { value: "22", text: "22" },
        { value: "23", text: "23" },
        { value: "24", text: "24" },
      ],
      to_year_arr: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
      ],
      agefrmto_default: [{ value: "", text: "-- Select --" }],
      factorysize: [],
      unit_arr: [
        { value: "0", text: "Month" },
        { value: "1", text: "Year" },
      ],
      index: 1,
      age_from: [],
      //age_to: [],
      age_to: [],
      temp_sizeset: 0,
      unit: [],
      selectedfromage: [],
      selectedtoage: [],
      selected_status_code_number: 0,
      counter: 0,
      count: 0,
      // massageForchild:"I am massage from parent component",
      all_Files_uploaded: 0,
      //New Added Code Ends
      fields3: [
        { key: "ID", lable: "ID", class: "design" },
        { key: "file_name", label: "File Name", class: "design" },
        { key: "filepath", label: "Download", class: "design" },
      ],
      items2: [],
      ismultiplselect: false,
      fileversion:'',
      selectedfilename:'',
      vendorDownloadLogList: [],
      showDownloadLogModal: false,
      fields4 : [
        { key: "vendor_name", lable: "Vendor Name", class: "design" },
        { key: "last_downloaded_date", lable: "Last Download Date", class: "design" },
        { key: "total_download_count", lable: "Total Download Count", class: "design" },
      ],
      isBusy4:false,
      sub_cattitle:'',
      isDragging: false,
    };
  },
  created: function() {
    this.getfileslisting();
    this.getdesigndetail();
    this.route_id = this.$route.params.id;
    var userData = localStorage.getItem("userData");
    var userInfo = JSON.parse(userData);
    this.user_type = userInfo[0].user_type;
    var userData = localStorage.getItem("userData");
    if (userData) {
      this.quote_tab = true;
      this.message_tab = true;
    }
  },
  methods: {
    checkpattern: function(value) {
      // alert(value)
      const regex = /^[1-9]\d*(\.\d+)?$/;
      const str = regex.test(value) ? "Match!" : "No Match";
      if (str === "No Match") {
        this.$fire({
          text: "Please Enter Positive Numbers Only",
          type: "warning",
          timer: 300000,
        });

        document.getElementById("upload_btn").style.display = "none";
      } else {
        document.getElementById("upload_btn").style.display = "block";
      }
    },
    selectfilecategory: function() {
      if (this.file_category == "Measurement Chart") {
        document.getElementById("sizesetData").style.display = "block";
      }
    },

    uploadfilemodelfunctionformultiple(value,name){
      this.fileversion = value;
      this.selectedfilename = name;
      // alert(this.selectedfilename)
      this.ismultiplselect = true;
      this.file_category = "";
      this.uploadfilemodel = true;
    },

    uploadfilemodelfunction: function() {
      this.ismultiplselect = false
      this.file_category = "";
      this.uploadfilemodel = true;
    },

    /************** BOM FUNCTION****************/
    // showBomModal: function() {
    //   const Obj = {
    //     brand_code: this.brand_id,
    //     file_type: "BOM",
    //   };

    //   axios
    //     .post(`${CONSTANTS.API_URL}/gettemplatefiles`, Obj)
    //     .then((response) => {
    //       this.result = response.data;
    //       if (this.result.returnmsg === "Successful") {
    //         this.items2 = this.result.returnvalue;
    //         //  this.filename = this.items2[0].file_name;
    //         //  console.log(this.filename);
    //         // this.filename = this.result.returnvalue[0].file_name;
    //         //  alert(response);
    //         this.totalRows = this.result.returnvalue.length;
    //         console.log(response);
    //       } else {
    //         this.items2 = [];
    //         this.totalRows = 0;
    //       }
    //     });
    //   //   .catch(e => {
    //   //   this.errors.push(e)
    //   // })
    // },


       showBomModal(){
        // alert(this.select_brandId)
        const Obj = {
            brand_id: this.brand_id,
            file_upload: "yes"
        };
        axios
            .post(`${CONSTANTS.API_URL}/getBOMList`, Obj)
            .then((response) => {
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
                this.items2 = this.result.returnvalue;
                this.totalRows = this.result.returnvalue.length;
        
            } else {
                this.items2 = [];
                this.totalRows = 0;

            }
            })
            .catch((e) => {
            this.errors.push(e);
            });
        },


    /****** Function to design details ********/
    getdesigndetail: function() {
      this.isBusy = true;

      const Obj = {
        style_id: this.$route.params.id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getdesigndetail`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.brand_id = this.result.returnvalue[0].brand_id;
            this.style_details = this.result.returnvalue[0];
            this.sub_cattitle = this.style_details.sub_cattitle;
            this.all_Files_uploaded = this.style_details.all_files_uploaded;
            this.temp_sizeset = this.style_details.no_of_sizeset;
            this.file_status = this.style_details.operational_status;
            this.sizeset = this.style_details.no_of_sizeset;
            this.selected_status_code_number = this.style_details.status_code_number;

            this.fileObj_msg = this.result.returnvalue[1].file_name;

            this.filemessage = this.result.returnvalue[1].file_name;
            for (var i = 0; i <= this.totalRows; i++) {
              if (this.style_details.status_code_number >= 8) {
                this.file_tab_status = true;
              }
            }
            if (
            this.result.returnvalue[1].file_name ==
              "Please upload Techpack,Measurement Chart and BOM files"
            ) {
              // alert(this.result.returnvalue[1].file_name);
              this.$fire({
                text: this.result.returnvalue[1].file_name,
                type: "success",
                timer: 30000,
              });
            }
            else if( this.result.returnvalue[1].file_name == "Please upload BOM and Measurement Chart"){
              // alert(this.result.returnvalue[1].file_name);
              this.$fire({
                text: this.result.returnvalue[1].file_name,
                type: "success",
                timer: 30000,
              });
              }
            this.fileObj = this.result.returnvalue[1].file_name;
            for (var i = 0; i <= this.fileObj.length; i++) {
              var file_name = this.fileObj[i].category_name;
              if (file_name == "Techpack") {
                this.tp_status = true;
              }
              if (file_name == "Measurement Chart") {
                this.measurementchart_status = true;
              }
              if (file_name == "BOM") {
                this.bom_status = true;
              }
              if (
                this.tp_status == true &&
                this.measurementchart_status == true &&
                this.bom_status == true
              ) {
                this.fileupload_status = true;
              }
            }

            this.getdesigndetail();
            this.getfileslisting();
            this.totalRows = this.result.returnvalue.length;
          } else {
            this.style_details = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    deletefile: function(id) {
      // document.getElementById("overlay").style.display = "block";
      if (confirm("Do you really want to delete?")) {
        const Obj = {
          id: id,
        };
        axios
          .post(`${CONSTANTS.API_URL}/deletedesignfile `, Obj)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              // Utils.notify("File Deleted Successfully", "success");
              this.$fire({
                text: "File Deleted Successfully",
                type: "success",
                timer: 30000,
              });
              this.getfileslisting();
            } else {
              // alert("Please Select Proper File")
              this.$fire({
                text: "Please Select Proper File",
                type: "warning",
                timer: 30000,
              });
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
      }
    },
    //Code For Delete File Ends

    /****** Function to design summary ********/
    getfileslisting: function() {
       var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
       this.user_type = userInfo[0].user_type;
      document.getElementById("overlay").style.display = "block";
      this.isBusy = true;
      const Obj = {
        style_id: this.$route.params.id,
        uploaded_by: userInfo[0].email_id,
        user_type: userInfo[0].user_type,
      };

      axios
        .post(`${CONSTANTS.API_URL}/getdesignfilelist `, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.files_list = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;

            this.isBusy = !this.isBusy;
          } else {
            this.files_list = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    /****** Function to Add Files********/
    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.addDesignFiles(scope);
        }
      });
    },

    selectFile(event) {
      this.selectedFiles = event.target.files[0];
      this.imgname = this.selectedFiles.name;
    },
    addDesignFiles() {
      if (!this.file) {
         this.$fire({
          text: "Please select a file to upload.",
          type: "warning",
          timer: 30000,
         });
        return;
        }
        if(this.selectedFiles == undefined || this.selectedFiles == null || this.selectedFiles == ''){
          this.$fire({
            text: "Please select a file to upload.",
            type: "warning",
            timer: 30000,
           });
          return;
        }


      document.getElementById("progress_bar").style.display = "block";
      document.getElementById("overlay").style.display = "block";
      this.id = this.$route.params.id;
      var main_arr = [];
      main_arr.push(this.invoice_products);

      // return false;
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      this.progress = 0;
      if (
        this.file_category != "" ||
        this.file_category != null ||
        this.file_category != undefined
      ) {
        let data = new FormData();
        // let file = event.target.files[0];
        // this.imgname= file.name;
        if(this.ismultiplselect == true){
            data.append("file_version", this.fileversion);
            data.append("category_name", this.selectedfilename);
          }else{
            data.append("category_name", this.file_category);
          }
        
        data.append("file", this.selectedFiles);
        data.append("style_id", this.id);
        data.append("file_name", this.imgname);
     
        data.append("created_by", userInfo[0].email_id);
        data.append("uploaded_by", userInfo[0].email_id);
        data.append("user_id", userInfo[0].user_id);
        data.append("sub_cattitle",this.sub_cattitle)
        if (
          (this.style_details.status_code_number >= 12 ||
            this.style_details.status_code_number != 13) &&
          this.file_category == "Measurement Chart"
        ) {
          // alert("In")
          data.append("size_details", JSON.stringify(main_arr));
        }


        let config = {
          header: {
            "Content-Type": "multipart/form-data",
          },
        };
        // return false;
        //Code For check file size > 10 MB
        // 10174700
        if (this.selectedFiles.size >= 62914560) {
          if (
            this.selectedFiles.type === "application/zip" ||
            this.selectedFiles.type === "application/x-xz" ||
            this.selectedFiles.type === "application/x-bzip" ||
            this.selectedFiles.type === "application/x-7z-compressed" ||
            this.selectedFiles.type === "application/vnd.rar"
          ) {
            axios
              .post(`${CONSTANTS.API_URL}/uploaddesignfiles`, data, {
                header: {
                  "Content-Type": "multipart/form-data",
                },
                onUploadProgress: function(progressEvent) {
                  this.progress = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  );
                }.bind(this),
              })
              .then((response) => {
                this.progress = Math.round(
                  (100 * response.loaded) / response.total
                );
                document.getElementById("overlay").style.display = "none";
                if (response.data.returnmsg == "Successful") {
                  // alert(" innnnn");
                  this.$fire({
                    text: "File Added Successfully.",
                    type: "success",
                    timer: 30000,
                  });
                  document.getElementById("progress_bar").style.display =
                    "none";
                  this.uploadfilemodel = false;
                  this.file_category = "";
                  this.selectedfilename = "";
                  this.file = null;
                  this.selectedFiles = null;
                   if (this.$refs.fileInput) {
                    this.$refs.fileInput.reset(); 
                  }
                  // if(this.user_type=='Fit_Technician'){
                  //   this.$router.push('/fittech_list');
                  // }

                  // else{
                  this.getdesigndetail();
                  this.getfileslisting();
                  // }
                  //this.$router.go(0);
                } else {
                  if (result.body.returnmsg === "NoUserExists") {
                    this.showAlert = true;
                    this.selectedfilename = "";
                  }
                  this.selectedfilename = "";
                }
              });
          } else {
            // alert("File Size is too large please upload Zip file");
            this.$fire({
              text: "Please upload file size within 60 Mb.",
              type: "warning",
              timer: 30000,
            });
            document.getElementById("progress_bar").style.display = "none";
            document.getElementById("overlay").style.display = "none";
          }
          //Code Ends for Zip File Check
        }
        //Code Ends for check file size>10MB
        else {
          axios
            .post(`${CONSTANTS.API_URL}/uploaddesignfiles`, data, {
              header: {
                "Content-Type": "multipart/form-data",
              },
              onUploadProgress: function(progressEvent) {
                this.progress = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
              }.bind(this),
            })
            .then((response) => {
              this.progress = Math.round(
                (100 * response.loaded) / response.total
              );
              document.getElementById("overlay").style.display = "none";
              if (response.data.returnmsg == "Successful") {
                // alert("innnn");
                // alert(" File Added Successfully.");
                this.$fire({
                  text: "File Added Successfully.",
                  type: "success",
                  timer: 30000,
                });
                document.getElementById("progress_bar").style.display = "none";
                // this.$router.push('/design_quotes/' + this.route_id);
                this.uploadfilemodel = false;
                this.file_category = "";
                this.selectedfilename = "";
                this.file = null;
                this.selectedFiles = null;
                  if (this.$refs.fileInput) {
                  this.$refs.fileInput.reset(); 
                }
                // if(this.user_type=='Fit_Technician'){
                //   this.$router.push('/fittech_list');
                // }
                // else{
                this.getdesigndetail();
                this.getfileslisting();
                // }
                //this.$router.go(0);
              } else {
                if (result.body.returnmsg === "NoUserExists") {
                  this.showAlert = true;
                  this.selectedfilename = "";
                }
                this.selectedfilename = "";
              }
            });
        }
      } else {
        // alert("Please Select File Type");
        this.$fire({
          text: "Please Select File Type.",
          type: "warning",
          timer: 30000,
        });
      }
    },

    onClose() {
      this.visible = false;
      this.selectedfilename = "";
    },

    closefileuploadmodal(){
      this.uploadfilemodel = false;
      this.selectedfilename = "";
      this.file_category = "";
      this.file = null;
      this.selectedFiles = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.reset(); 
      }
    },

    openDownloadLogModel(file_id){
      document.getElementById("overlay").style.display = "block";
      this.showDownloadLogModal = true
      const Obj = {
        file_id
      };
      this.isBusy4 = true
      axios
        .post(`${CONSTANTS.API_URL}/getVendorDownloadLogListing`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "block";
          // this.result = response.data;
          if (response.data.returnmsg === "Successful") {
            let tempArr = response.data.returnvalue
            tempArr.map(item => item.last_downloaded_date = (new Date(item.last_downloaded_date).getDate()+'/'+ (new Date(item.last_downloaded_date).getMonth() + 1) +'/'+ new Date(item.last_downloaded_date).getFullYear() ) )
            this.vendorDownloadLogList = tempArr
            this.showDownloadLogModal = true
            document.getElementById("overlay").style.display = "none";
            this.isBusy4 = false
          }else {
            this.vendorDownloadLogList = []
            document.getElementById("overlay").style.display = "none";
            this.isBusy4 = false
          }
        })
        .catch((e) => {
          this.errors.push(e);
          document.getElementById("overlay").style.display = "none";
          this.isBusy4 = false
        });
    },

    getRowIndex(row) {
      // Calculate the index based on the current page and items per page
      return (this.currentPage - 1) * this.perPage + row.index + 1;
    },

    handleDragEnter() {
    this.isDragging = true;
  },
  handleDragOver() {
    this.isDragging = true;
  },
  handleDragLeave() {
    this.isDragging = false;
  },
handleDrop(e) {
  this.isDragging = false;

  const newFile = e.dataTransfer.files[0];
  if (!newFile) return;

  const allowed = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
  if (!allowed.includes(newFile.type)) {
    this.$bvToast.toast("Invalid file type. Upload PDF or Image.", {
      title: "Error",
      variant: "danger",
      solid: true,
    });
    return;
  }

  // ----- Important -----
  // Override previous file
  this.selectedFiles = newFile;
  this.imgname = newFile.name;
  this.file = newFile;     // for showing UI

  // Sync to <b-form-file> input
  const dt = new DataTransfer();
  dt.items.add(newFile);
  this.$refs.fileInput.$el.files = dt.files;
},



  },
};
</script>
<style>
.short-div {
  height: 55px;
}

.quote-dropdowns .dropdown--accepted {
  border-top: 1px solid var(--fill-green-dark);
}

.quote-dropdowns > .card {
  background-color: var(--fill-white);
}
.quote-dropdowns .dropdown__header.dropdown__header--accepted {
  border: 1px solid var(--fill-green-dark);
  border-top: none;
  background-color: #e8fff5;
}
.card .card__section {
  flex-grow: 1;
  box-shadow: inset 0 -1px 0 0 #e5e5e5;
  box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .dropdown__header {
  align-items: center;
  justify-items: center;
  justify-content: center;
  cursor: pointer;
}
.quote-dropdowns .card__section {
  padding: 16px 32px;
}
.f-sz-l {
  font-size: 15px;
}
.flex-col {
  flex-direction: column;
}
.flex,
.flex-col {
  display: flex;
}
.f-w-semi-bold {
  font-weight: 600;
}
.f-sz-sm {
  font-size: 12px;
}
.f-w-semi-bold {
  font-weight: 600;
}

.card .card__section {
  flex-grow: 1;
  box-shadow: inset 0 -1px 0 0 #e5e5e5;
  box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .card__section {
  padding: 16px 32px;
}

.input-grp {
  width: 100%;
  margin-bottom: 16px;
}
.input-grp {
  margin-bottom: 10px !important;
}

.input-grp label {
  margin-bottom: 6px;
  color: #333340;
}

input[type="number"],
input[type="password"],
input[type="tel"],
input[type="text"] {
  padding: 13px 12px;
  border-radius: 2px;
  border: 1px solid #bfbfbf;
}
.input-grp input,
.input-grp label,
.input-grp select {
  display: block;
  width: 100%;
}

.input-grp select:disabled {
  background-color: #ebebe4;
}
.input-grp select {
  background: url(/static/media/ic-arrow-drop-down.1f6abe65.svg) no-repeat;
  background-position: right 8px top 6px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}

.quote-dropdowns .dropdown__header.dropdown__header--accepted {
  border: 1px solid var(--fill-green-dark);
  border-top: none;
  background-color: #e8fff5;
}

.main_body1 {
  width: 970px;
}
/*.card-footer{
    border-radius: 0 0 15px 15px !important;
      border-top: 0 !important;
      background-color: #F5F5F5 !important;

  }*/
.container {
  align-content: center;
}
.search {
  border-radius: 15px 0 0 15px !important;
  background-color: white !important;
  border: 0 !important;
  color: white !important;
}
.search:focus {
  box-shadow: none !important;
  outline: 0px !important;
}
/*.type_msg{
      background-color: white !important;
      border:0 !important;
      color:white !important;
      height: 60px !important;
      overflow-y: auto;
    }*/
#type_msg:focus {
  box-shadow: none !important;
  outline: 0px !important;
}
.send_btn {
  border: 1 !important;
  border-color: #20a8d8;
  background-color: #4d94ff;
  cursor: pointer;
}
.search_btn {
  border-radius: #20a8d8 !important;
  border: 0 !important;
  background-color: #20a8d8;
  cursor: pointer;
}
.contacts {
  list-style: none;
  padding: 0;
}
.contacts li {
  width: 100% !important;
  padding: 5px 10px;
  margin-bottom: 15px !important;
}

.user_img {
  height: 40px;
  width: 30px;
  border: 1.5px solid #f5f6fa;
  margin-left: 10px;
}
.user_img_msg {
  height: 30px;
  width: 30px;
  border: 1.5px solid #f5f6fa;
}
.text-span {
  background: blue;
  border-radius: 50%;
  height: 26px;
  width: 26px;
  line-height: 26px;
  display: inline-block;
  text-align: center;
  margin-right: 6px;
}
.text-span2 {
  background: gray;
  border-radius: 50%;
  height: 26px;
  width: 26px;
  line-height: 26px;
  display: inline-block;
  text-align: center;
  margin-right: 6px;
}
.brand-card {
  border-radius: 0px !important;
}

.sidebar {
  background: #17a2b8 !important;
  width: 50px !important;
}

.sidebar .sidebar-nav {
  width: 50px !important;
}
.sidebar .nav {
  width: 50px !important;
}

.main {
  margin-left: 50px !important;
}
#rec_msg {
  margin-left: 40%;
  position: absolute;
}
.tabledesign {
  padding-left: 0px;
}

/*** Tabb ***/
.header-tabs__navbar {
  margin-top: auto;
  align-items: center;
  border-top: 1px solid var(--fill-grey-light2);
}
.flex {
  display: flex;
}

.header-tabs__tab {
  position: relative;
  flex: 1 1;
  height: 43px !important;
  padding: 12px 22px;
  border-bottom: 3px solid var(--fill-grey-light3);
  display: flex;
  flex-direction: row;
  cursor: pointer;
  border: 1px solid #63c2de;
  border-radius: 12px;
}

.header-tabs__tab-image {
  padding-right: 8px;
}

.header-tabs__tab-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.header-tabs__tab .sub_title {
  font-size: 12px;
  line-height: 16px;
  text-transform: capitalize;
  font-weight: 400;
  color: var(--fill-grey-medium);
}

html,
body {
  margin: 0;
}
.wrapper {
  display: flex;
  flex-direction: column;
  height: 92vh;
  width: 100%;
  background-color: white;
}

/*Todays CSS*/
.nav_row_tabs {
  display: flex;
  border-top: 1px solid #d7dbdd;
  border-bottom: 1px solid #d7dbdd;
}

#activeTitle {
  font-size: 14px;
}
.brandcard {
  border-radius: 0px !important;
  padding-left: 10px !important;
}
.trbody {
  word-break: break-all;
}
@media (max-width: 576px) {
  .trhead {
    font-size: 12px;
  }
  .trbody {
    font-size: 12px;
  }
}
@media (max-width: 320px) and (min-width: 300px) {
  .trhead {
    font-size: 10px;
  }
  .trbody {
    font-size: 10px;
  }
}
@media (max-width: 280px) {
  .trhead {
    font-size: 9px;
  }
  .trbody {
    font-size: 9px;
  }
}
@media (max-width: 1040px) {
  .fileside {
    display: none;
  }
}
@media (min-width: 540px) {
  .filenote {
    display: none;
  }
}
@media (max-width: 500px) and (min-width: 410px) {
  .fileshead {
    font-size: 0.75em;
  }
  .filesbody {
    font-size: 0.75em;
  }
  .fileunit {
    padding: 2px;
    width: 65px;
  }
  .filefromage {
    width: 55px;
    padding: 2px;
  }
  .filetoage {
    width: 55px;
    padding: 2px;
  }
  .filefactory {
    width: 70px;
    height: 10px;
  }
}
@media (max-width: 400px) and (min-width: 350px) {
  .brandcard {
    padding-left: 15px !important;
  }

  .fileshead {
    font-size: 0.625em;
  }
  .filesbody {
    font-size: 0.625em;
  }
  .fileunit {
    padding: 1px;
    width: 65px;
  }
  .filefromage {
    width: 50px;
    padding: 1px;
  }
  .filetoage {
    width: 50px;
    padding: 1px;
  }
  .filefactory {
    width: 60px;
    height: 10px;
    padding: 2px;
  }
}
@media (max-width: 360px) {
  .brandcard {
    padding-left: 12px !important;
  }
}
@media (max-width: 340px) {
  .fileshead {
    font-size: 0.625em;
  }
  .filesbody {
    font-size: 0.625em;
  }
  .fileunit {
    padding: 1px;
    width: 65px;
    font-size: 11px;
  }
  .filefromage {
    width: 40px;
    padding: 2px;
    font-size: 11px;
  }
  .filetoage {
    width: 40px;
    padding: 2px;
    font-size: 11px;
  }
  .filefactory {
    width: 50px;
    padding: 2px;
    font-size: 11px;
    height: 10px;
  }
  /*.filedesign{
  padding-left: 5px !important;
}*/
}
/*@media (max-width: 280px) 
{
 .fileshead{
    font-size:0.5625em;
}
.filesbody{
    font-size:0.5625em;
}
.fileunit{
  padding: 1px;
    width: 65px;
   font-size:10px ;
}
.filefromage{
  width:35px;
   padding:0px;
   font-size:10px ;
}
.filetoage{
 width:35px;
   padding:0px;
   font-size:10px ;
}
.filefactory{
 width:40px;
   padding:2px;
    font-size:11px ;
  height: 10px;
 
  
}
.filedesign{
  padding-left: 0px !important;
}
}*/
/*@media (max-width: 375px)
{
.trhead{
  font-size:10px;
}
.trbody{
  font-size: 10px;
}
}
@media (max-width: 320px)
{
.trhead{
  font-size:9px;
}
.trbody{
  font-size: 9px;
}
}
@media (max-width: 280px)and (min-width: 300px)
{
.trhead{
  font-size:9px;
}
.trbody{
  font-size: 9px;
}

}*/
</style>
